module.exports = __webpack_public_path__ + "img/img-21.5e5ebdff.jpeg";